export default __webpack_public_path__ + "static/media/login-01.18eb1a39.jpg";